export class ReportDto {
  reportGuid: string = ''
  name: string = ''
  description: string = ''
  specialIdentifier: string = ''
}

export class PersonReportsDto {
  reports: ReportDto[] = []
}

export class UpdatePersonReportsDto {
  reportGuids: string[] = []
}

export const REPORT_SPECIAL_IDENTIFIERS = {
  CUSTOMER_EXPORT_REPORT: 'CUSTOMER_EXPORT_REPORT',
  FINANCIAL_TRANSACTIONS_ADDED_AFTER_INVOICING_REPORT: 'FINANCIAL_TRANSACTIONS_ADDED_AFTER_INVOICING_REPORT'
} as const
